import { Field, Label, Widget } from '@kanda-libs/ks-component-ts';
import { Button } from '@kanda-libs/ks-design-library';
import AddressFields from 'components/form/Address';
import { AGREED_TERMS_PROPS, TERMS_COPY, TERMS_URL } from './constants';
import useEnquiryContactDetailsFormContactFields from './useEnquiryContactDetailsFormContactFields';

export interface EnquiryContactDetailsFormFieldsProps {
  showAddress?: boolean;
}

const EnquiryContactDetailsFormFields: React.FunctionComponent<EnquiryContactDetailsFormFieldsProps> =
  function ({ showAddress = true }) {
    const { disabled, isLoading, isSubmitting } =
      useEnquiryContactDetailsFormContactFields();
    return (
      <>
        <div className="flex flex-col md:flex-row gap-x-4">
          <Widget.CustomerFirstName placeholder="First name" />
          <Widget.CustomerLastName placeholder="Last name" />
        </div>
        <div className="flex flex-col md:flex-row md:flex-wrap gap-x-4">
          <div className="flex-1 min-w-50">
            <Widget.CustomerEmail placeholder="Email address" />
          </div>
          <div className="flex-1 min-w-50">
            <Widget.CustomerPhone placeholder="07123456789" />
          </div>
        </div>
        <div className="w-full mt-3 mb-6 border-b border-neutral-300" />
        {showAddress && <AddressFields baseFieldName="customer.address" />}
        <div className="flex flex-col text-left">
          <Label label="Do you agree to our terms and conditions?" />
          <div className="mb-1" />
          <Field.FingerprintBooleanInput
            {...AGREED_TERMS_PROPS}
            fieldText={
              <div className="flex flex-row text-left">
                <p className="my-auto text-14-22 text-neutral-700">
                  {TERMS_COPY.part1}
                  <a
                    href={TERMS_URL}
                    className="text-purple-400"
                    target="_blank"
                    rel="noreferrer"
                  >
                    {TERMS_COPY.link}
                  </a>
                  {TERMS_COPY.part2}
                </p>
              </div>
            }
          />
        </div>
        <Button.Text
          id="enquiry-contact-details-submit"
          submit
          label="Next"
          variant="gradient"
          disabled={isLoading || isSubmitting || disabled}
          className="mt-6"
        />
      </>
    );
  };

export default EnquiryContactDetailsFormFields;
